import * as types from '../../constants/ActionTypes'
import { createBasicCreator, fetchData } from '../Buy'

/**
 * BRUM-808
 * PROCESSO D'ACQUISTO: organizzazione integrazione opzioni di consegna/logistica nel frontend
 */

const newLogisticaCentriConvenzionati = createBasicCreator(
  types.NEW_LOGISTICA_CENTRI_CONVENZIONATI
)

const fetch_getLogisticaCentriConvenzionati = (
  actionType,
  productLine = 'vendita'
) => {
  const _fetchData = fetchData(actionType)

  return () =>
    _fetchData({
      method: 'get',
      uri: `${window.brumbrum.url_api}/logistica/p/v2/citta-consegna/${productLine}`,
      callback: newLogisticaCentriConvenzionati,
    })
}

export const getLogisticaCentriConvenzionati =
  fetch_getLogisticaCentriConvenzionati(
    types.GET_LOGISTICA_CENTRI_CONVENZIONATI
  )

export const getLogisticaCentriConvenzionatiNltBrumbrum =
  fetch_getLogisticaCentriConvenzionati(
    types.GET_LOGISTICA_CENTRI_CONVENZIONATI,
    'noleggio-brumbrum'
  )

export const setLogisticaCentroConvenzionato = createBasicCreator(
  types.SET_LOGISTICA_CENTRO_CONVENZIONATO
)
export const setCompassCalcolatriceLogistica = createBasicCreator(
  types.SET_COMPASS_CALCOLATRICE_LOGISTICA
)
export const setLogisticaCodiceProvincia = createBasicCreator(
  types.SET_LOGISTICA_CODICE_PROVINCIA
)
